module.exports = __webpack_public_path__ + "img/follow.fc439a0c.png";